import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';

@Component({
    selector: 'app-add-asset',
    templateUrl: './add-asset.component.html',
    styleUrls: ['./add-asset.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class AddAssetComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private datepipe = inject(DatePipe);

  @Input() companyBankAccountList: Account[] = [];
  @Input() cashAccountList: Account[] = [];

  selectedAccountId: number;
  isReturn: boolean;
  @Output() passEntry = new EventEmitter<any>();

  //2-WAY BINDING INFO
  date: Date;
  remark: string;
  amount = 0;

  disabledSubmit = false;
  constructor() {
    this.date = new Date();
  }

  ngOnInit(): void {
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined)
    const paymentValid = (isNaN(+this.amount))

    return paymentNull || remarkNull || selectedAccountIdNull || paymentValid
  }

  getLastestCheckInDateBeforeAssetDate(companyId: number) {
    const assetDateStr = new Date(Number(this.date)).toISOString();
    const xhttp = this.restapi.getRequest(this.constructApi.getCompaniesLatestCheckIns(companyId, assetDateStr));

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {
          //last check in date
          const lastDate = this.datepipe.transform(new Date(json.date), 'dd-MM-yyyy');

          const dayBeforeAssetDate = new Date(this.date); //current assetDate
          dayBeforeAssetDate.setDate(dayBeforeAssetDate.getDate() - 1) //minimum need verify 24 hours before asset date
          const dayBeforeAssetDateStr = this.datepipe.transform(dayBeforeAssetDate, 'dd-MM-yyyy');

          //check if last verified date = 24 hours before asset date
          if (lastDate == dayBeforeAssetDateStr)
            this.addAndApproveAsset();
          else {
            this.sharedService.openAlert("Please verify your account on  (" + this.date.getFullYear() + "/" + (this.date.getMonth() + 1) + "/" + (this.date.getDate() - 1) + ")", ALERT_TYPE.DANGER);
          }
        });
      }
    };
  }

  addAndApproveAsset() {
    this.disabledSubmit = true;

    const isoTaskDate = (new Date(Number(this.date))).toISOString();
    const companyId = Number(sessionStorage.getItem("companyId"));

    const amount = (this.isReturn) ? -this.amount : this.amount;
    const data = {
      "companyId": companyId,
      "amount": amount,
      "accountId": Number(this.selectedAccountId),
      "dateCreated": isoTaskDate,
      "remark": this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddAsset(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            const json = JSON.parse(xhr.responseText);
            const assetID = json.id;
            this.approveAsset(assetID);
          }
          else {
            this.disabledSubmit = false;
            this.sharedService.openErrorMessage(xhr);
          }
        }
      }
    }
  }

  approveAsset(assetID: number) {
    const isoTaskDate = (new Date(Number(this.date))).toISOString();

    const data = {
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getApproveAsset(assetID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        // var json = JSON.parse(xhr.responseText);
        let account;
        if (this.isReturn)
          account = new Account(this.selectedAccountId, null, null, null, null, null, null, -this.amount)
        else
          account = new Account(this.selectedAccountId, null, null, null, null, null, null, this.amount)
        this.passEntry.emit(account)
        this.reset();
        this.sharedService.openAlert("Successfully approved asset!", ALERT_TYPE.SUCCESS);
        window.location.reload();
      }
    }
  }

  submit() {
    if (this.isFieldNull()) {
      this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER)
    }
    else if (this.isReturn && this.checkAccountBalanceSufficient() == false) {
      this.sharedService.openAlert('This account does not have enough money', ALERT_TYPE.DANGER);
    }
    else {
      const companyId = Number(sessionStorage.getItem("companyId"));
      this.getLastestCheckInDateBeforeAssetDate(companyId);
    }
  }

  checkAccountBalanceSufficient() {
    let index = this.cashAccountList.findIndex(account => Number(account.ID) == Number(this.selectedAccountId));

    if (index == -1) {
      index = this.companyBankAccountList.findIndex(account => Number(account.ID) == Number(this.selectedAccountId));

      if (this.companyBankAccountList[index].Balance - this.amount < 0)
        return false;
    }
    else {
      if (this.cashAccountList[index].Balance - this.amount < 0)
        return false;
    }
    return true;
  }

  reset() {
    this.activeModal.close();
  }
}
